import React from 'react';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

function isOk(field) {
    return field === undefined;
}

function helperText(field, intl) {
    return field === undefined || field.length === 0 ? intl.formatMessage({ id: 'required' }) : '';
}

class Item extends React.Component {
    state = {
        nombre: this.props.item ? this.props.item.valor : '',
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleClose = (name, score) => (event) => {
        this.props.handleClose(name, score);
    };

    isCorrect = () => {
        const { nombre } = this.state;
        return nombre && nombre.length > 0 ? true : false;
    };

    render() {
        const { nombre } = this.state;
        const { intl } = this.props;
        return (
            <Dialog
                open={true}
                onClose={this.handleClose(null, null)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent className={'padding_borders'}>
                    <TextField
                        autoFocus
                        fullWidth
                        id={'nombre'}
                        name={'nombre'}
                        required
                        error={isOk(nombre)}
                        helperText={helperText(nombre, intl)}
                        label={intl.formatMessage({ id: 'form_field_name_nombre' })}
                        className={'flex_full_row'}
                        value={nombre}
                        onChange={this.handleChange}
                        margin="normal"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClose(null, null)} color="primary">
                        <FormattedMessage id="cancel" />
                    </Button>
                    <Button
                        onClick={this.handleClose(nombre)}
                        color="primary"
                        autoFocus
                        disabled={!this.isCorrect()}
                    >
                        <FormattedMessage id="accept" />
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

Item.propTypes = {
    intl: intlShape.isRequired,
};

Item = injectIntl(Item);

export default Item;



// WEBPACK FOOTER //
// ./src/components/complex/inventory/catalog/Item.js